import React from "react";
import { Link } from "react-router-dom";
import "./FeatureGrid.css";
import Icon from "./Icon.jsx";

import hotelImg from "../assets_optimized/boutique-hotel.webp";
import residentialImg from "../assets_optimized/residential-interior.webp";
import consultationImg from "../assets_optimized/design-consult.webp";
import collectionsImg from "../assets_optimized/bespoke.webp";

const FEATURES = [
  {
    title: "Hotel & Hospitality Design",
    desc: "From boutique properties to large-scale ventures—elegant, sophisticated hotel interiors that captivate guests and reflect refined luxury.",
    image: hotelImg,
    link: "/services",
  },
  {
    title: "Residential Interiors",
    desc: "Transforming homes into elegant sanctuaries with timeless design and curated luxury collections.",
    image: residentialImg,
    link: "/services",
  },
  {
    title: "Design Consultation",
    desc: "Expert guidance to help you create spaces that embody sophistication and refined elegance.",
    image: consultationImg,
    link: "/services",
  },
  {
    title: "Bespoke Collections",
    desc: "Curated furniture and decor pieces selected for their elegance, quality, and timeless appeal.",
    image: collectionsImg,
    link: "/services",
  },
];

export default function FeatureGrid() {
  return (
    <section className="section" id="expertise">
      <div className="container">
        <div className="fgHead">
          <div>
            <div className="fgKicker">
              <span className="fgDot" aria-hidden="true" /> Our Expertise
            </div>
            <h2 className="fgTitle">Protek Design Studio</h2>
            <p className="fgText">
              We specialize in creating sophisticated interiors for projects of
              all scales—from boutique spaces to large ventures and commercial
              buildings. Our designs blend timeless elegance with
              contemporary luxury, crafting environments that captivate and
              inspire.
            </p>
          </div>

          <Link to="/contact" className="btn fgBtn">
            Start Project <Icon name="arrow" />
          </Link>
        </div>

        <div className="fgGrid">
          {FEATURES.map((f) => (
            <article key={f.title} className="fgImgCard">
              <div className="fgImgWrap">
                <img
                  className="fgImg"
                  src={f.image}
                  alt={f.title}
                  loading="lazy"
                />

                <div className="fgOverlay">
                  <h3 className="fgOverlayTitle">{f.title}</h3>
                  <p className="fgOverlayDesc">{f.desc}</p>
                  <Link to={f.link} className="fgLearnBtn">
                    Learn more <Icon name="arrow" />
                  </Link>
                </div>

                <div className="fgBaseTitle">{f.title}</div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
